import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import { useNavigate } from 'react-router-dom';
import { Button, KeyVal, Page, Input } from 'equasion-lib';
import ActionTopBar from '@/lib/shared-coms/ActionTopBar';
import WarehouseProductDisplay from '@/lib/shared-coms/WarehouseProductDisplay';
import { FiCheckCircle } from 'react-icons/fi';
import { destroyDefaults, destroyValidation } from './Destroy.validation';
import './Destroy.scss';

const Destroy = ({
  serializedItemState,
  bulkInventoryEventCreate,
  selectedCompanyId
}) => {
  const navigate = useNavigate();
  const [destroyed, setDestroyed] = useState(false);
  const { itemBreakdown, serialNumber, gtin } = serializedItemState || {};

  const submitBulkInventoryEventCreate = async (values, actions) => {
    const { setSubmitting } = actions;
    const { destructionReason } = values;
    try {
      await bulkInventoryEventCreate({
        variables: {
          serialNumber,
          gtin,
          companyId: selectedCompanyId,
          destructionReason,
          inventoryEventAttributes: {
            type: 'DESTROY',
            companyId: selectedCompanyId
          }
        }
      });
      setDestroyed(true);
    } catch (e) {
      console.log(`ERROR UPDATING PRODUCTS: ${e}`);
    }
    setSubmitting(false);
  };

  return (
    <Page className="destroy action-page">
      <ActionTopBar action="Destroy" serialNumber={serialNumber} actionColor="#C42525" />
      <Formik
        initialValues={destroyDefaults()}
        validationSchema={destroyValidation()}
        validateOnBlur={false}
        onSubmit={submitBulkInventoryEventCreate}
        enableReinitialize
      >
        {({ isSubmitting, values }) => {
          const { destructionReason } = values;
          return (
            <Form className="destruction-form">
              <div className="action-page-body">
                <KeyVal
                  items={[
                    {
                      key: 'Serial',
                      value: serialNumber
                    }
                  ].filter(Boolean)}
                />
                {(itemBreakdown || []).map(({ quantity, lot, product }) => (
                  <div key={product.id}>
                    <WarehouseProductDisplay product={product} />
                    Lot #: {lot} <br />
                    Qty: {quantity} <br />
                  </div>
                ))}
                <Input
                  name="destructionReason"
                  label="Reason for destruction..."
                  inputType="textarea"
                />
                <Button type="danger" fullWidth isSubmit disabled={isSubmitting}>
                  Destroy
                </Button>
              </div>
              <div
                className={['result-panel', destroyed && 'open']
                  .filter(Boolean)
                  .join(' ')}
              >
                <div className="result-message">
                  <FiCheckCircle style={{ color: 'var(--green)' }} />
                  <h1>Destroyed Successfully</h1>
                  <p>The following item has been destroyed.</p>
                </div>
                <KeyVal
                  items={[
                    {
                      key: 'Serial',
                      value: serialNumber
                    }
                  ].filter(Boolean)}
                />
                {(itemBreakdown || []).map(({ quantity, lot, product }) => (
                  <div key={product.id}>
                    <WarehouseProductDisplay product={product} />
                    Lot #: {lot} <br />
                    Qty: {quantity} <br />
                  </div>
                ))}
                <b>Reason for destruction</b> <br />
                {destructionReason}
                <div className="result-actions">
                  <Button type="primary" fullWidth onClick={() => navigate('/')}>
                    Done
                  </Button>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </Page>
  );
};

export default Destroy;
